import React from "react";

// Default data for the table
export const defaultResourceAllocationData = [
  {
    sustainabilityMatter: "",
    capex: "",
    opex: "",
    allocationYear: "",
    futureResources: "",
  },
  {
    sustainabilityMatter: "",
    capex: "",
    opex: "",
    allocationYear: "",
    futureResources: "",
  },
];

const ResourceAllocationTable = ({ resourceData, setResourceData }) => {
  const handleChange = (index, field, value) => {
    const updatedData = [...resourceData];
    updatedData[index][field] = value;
    setResourceData(updatedData);
  };

  React.useEffect(() => {
    if (!resourceData || resourceData.length === 0) {
      setResourceData(defaultResourceAllocationData);
    }
  }, []);

  return (
    <div
      style={{
        marginTop: "20px",
        overflowX: "auto",
        border: "0.6px solid #999",
        borderRadius: "12px",
        overflow: "hidden",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "separate",
          borderSpacing: 0,
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={tableHeaderStyle}>Sustainability Matter</th>
            <th style={tableHeaderStyle}>CapEx (EUR)</th>
            <th style={tableHeaderStyle}>OpEx (EUR)</th>
            <th style={tableHeaderStyle}>Year of Allocation</th>
            <th style={tableHeaderStyle}>Planned Future Resources</th>
          </tr>
        </thead>
        <tbody>
          {resourceData.map((row, index) => (
            <tr key={index}>
              <td style={tableCellStyle}>
                <input
                  type="text"
                  placeholder="Enter"
                  value={row.sustainabilityMatter}
                  onChange={(e) =>
                    handleChange(index, "sustainabilityMatter", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
              <td style={tableCellStyle}>
                <input
                  type="number"
                  placeholder="Enter"
                  value={row.capex}
                  onChange={(e) => handleChange(index, "capex", e.target.value)}
                  style={inputStyle}
                />
              </td>
              <td style={tableCellStyle}>
                <input
                  type="number"
                  placeholder="Enter"
                  value={row.opex}
                  onChange={(e) => handleChange(index, "opex", e.target.value)}
                  style={inputStyle}
                />
              </td>
              <td style={tableCellStyle}>
                <input
                  type="text"
                  placeholder="Enter"
                  value={row.allocationYear}
                  onChange={(e) =>
                    handleChange(index, "allocationYear", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
              <td style={tableCellStyle}>
                <input
                  type="text"
                  placeholder="Enter"
                  value={row.futureResources}
                  onChange={(e) =>
                    handleChange(index, "futureResources", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles (same as previous tables)
const tableHeaderStyle = {
  padding: "14px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "15px",
};

const tableCellStyle = {
  padding: "14px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "15px",
};

const inputStyle = {
  width: "90%",
  padding: "10px",
  borderRadius: "8px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
};

export default ResourceAllocationTable;
